import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom"
import * as actions from './redux/actions';
import BannerNavMenu from './BannerNavMenu'
import BannerBody from './BannerBody.js'
export class BannerNav extends Component {
  static propTypes = {
    disciplineList: PropTypes.array.isRequired
  };
  render() {
    let { disciplineList = [], menuList } = this.props
    let { isShowAdImage } = this.props.home;
    return (
      <div className={isShowAdImage ? "home-banner-nav_1" : "home-banner-nav"}>
        <div className="home-banner-navs">
          <div className="home-banner-navs-wrap">
            <BannerNavMenu menuList={menuList} />
          </div>
          <BannerBody disciplineList={disciplineList} />
          {/* <div className="home-banner-nav-adv">
            <div className="home-banner-nav-adv-wrap">
              <div className="adv-1"></div>
              <div className="adv-2"></div>
              <div className="adv-2"></div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BannerNav));



// WEBPACK FOOTER //
// ./src/features/home/BannerNav.js